import React from 'react';
import AuthWrapper from '../components/molecules/AuthWrapper';
import ReadingPlatformTemplate from '../components/templates/ReadingPlatform';

const ReadingPlatform = () => {
  return <AuthWrapper renderProps={ReadingPlatformTemplate} />;
};

export default ReadingPlatform;
